<template>
  <div class="form-row align-items-end">
    <div v-if="$mods.billing.access_all_families && can(PERMISSIONS.ACCESS_ALL_FAMILIES)" class="col-3">
      <form-select :label="Lang.get('messages.branch')" :options="SchoolsForSelect" name="school" :model="localFilters"
        label-field="name" value-field="id" :reduce="(value) => value.id"
        @change="(e) => { loadAllDataToSelects(); updateSelectedNames(); }" :multiple="isSuperadminLoggedSchool" :selectAllOption="false" />
    </div>


    <div class="col-md-3" v-if="showAcademicYear">
      <form-select :label="Lang.get('messages.academic_year')" :options="academicYears" name="academicYear"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id"
        @change="(e) => { clearInput('academicYear'); setEnrollment(); }" />
    </div>

    <div class="col-md-3" v-if="showAnotherAcademicYear">
      <form-select :label="Lang.get('messages.another_academic_year')" :reduce="(value) => value.id"
        :options="academicYears" name="doesnotHaveAcademicYearEnrollment" :model="localFilters" :errors="formErrors"
        label-field="name" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.stage')" :options="stagesForSelect" name="stageEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name" @change="getYearLevels()"
        :reduce="(value) => value.id" />
    </div>

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.yearLevel')" :options="yearLevelForSelect" name="yearLevelEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id"
        @change="(e) => { getClasses(); updateSelectedNames(); }" />
    </div>

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.class')" :options="classes" name="classEnrollment" :model="localFilters"
        :errors="formErrors" label-field="name" @change="(e) => { clearInput('class'); updateSelectedNames(); }"
        :reduce="(value) => value.id" />
    </div>

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.religion')" :reduce="(value) => value.id" :options="religionsForSelect"
        name="religion" :model="localFilters" :errors="formErrors" label-field="name" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.enrolled_year')" :options="academicYears" name="enrolledAcademicYear"
        :model="localFilters" :errors="formErrors" label-field="name" @change="clearInput('enrolledAcademicYear')" />
    </div>

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.gender')" :reduce="(value) => value.id" :options="genderForSelect"
        name="gender" :model="localFilters" :errors="formErrors" label-field="name" />
    </div>
    <!--    <div class="col-md-1" v-if="$mods.students.form_inputs.unspecified_nationality">-->
    <!--      <form-switch :label="Lang.get('messages.unspecified_nationality')"-->
    <!--                   name="unspecifiedNationality" :model="localFilters" :errors="formErrors"-->
    <!--                   @change="((value)=>unspecifiedNationalityStatusChange(value))"/>-->
    <!--    </div>-->

    <!--    <div class="col-md-3" v-if="$mods.students.form_inputs.unspecified_nationality">-->
    <!--      <form-select :label="Lang.get('messages.unspecified_nationality')" :options="UnspecifiedNationalitiesForSelect"-->
    <!--                   name="unspecifiedNationality" :model="localFilters"-->
    <!--                   label-field="name" :reduce="(value)=>value.id" @change="((value)=>{unspecifiedNationalityStatusChange(value);clearInput('unspecified_nationality')})"/>-->
    <!--    </div>-->

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.nationality')" :reduce="(value) => value.name_en"
        :options="nationalitiesForSelect" name="nationalityKeyword" :model="localFilters" :errors="formErrors"
        label-field="name" :disabled="unspecifiedNationalityStatus" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.student_type')" :options="studentTypesForSelect" name="studentType"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id" />
    </div>
    <div class="col-md-3" v-if="route != '/students/report/transformation-students'">
      <form-select :label="Lang.get('messages.student_status')" :reduce="(value) => value.id" :options="studentStatus"
        name="status" :model="localFilters" :errors="formErrors" label-field="name" />
    </div>
    <div class="col-md-3" v-if="previousSchool && route == '/students/report/transformation-students'">
      <form-select :label="Lang.get('messages.transform_school')" :options="prevSchoolsForSelect" name="transformSchool"
        :model="localFilters" :reduce="(value) => value.id" :errors="formErrors" label-field="name" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.registration_status')" :options="registrationStatusForSelect"
        name="registrationType" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(val) => val.id" />
    </div>

    <div class="col-md-3" v-if="studyStatus">
      <form-select :label="Lang.get('messages.study_status')" :options="studyStatusForSelect" name="studyStatus"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(val) => val.id" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.select_district')" :options="districts" name="districtId"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(val) => val.id" @change="getArea"
        @keyup="clearInput('district')" />
    </div>

    <div class="col-md-3">
      <form-select :label="Lang.get('messages.select_area')" :options="areas" name="areaId" :model="localFilters"
        :errors="formErrors" label-field="name" :reduce="(val) => val.id" @keyup="clearInput('area')" />
    </div>
    <div class="col-3">
      <form-input :label="Lang.get('messages.student_code')" name="code" :model="localFilters" />
    </div>
    <div class="col-3">
      <form-input :label="Lang.get('messages.student_civil_id')" name="civilId" :model="localFilters" />
    </div>
    <div class="col-3">
      <form-input :label="Lang.get('messages.father_civil_id')" name="fatherCivilId" :model="localFilters" />
    </div>
    <div class="col-md-3" v-if="$mods.school_settings.families.father.form_inputs.work_sector">
      <!--      <form-select-->
      <!--          :label="Lang.get('messages.father_work_sector')"-->
      <!--          :reduce="(value) => value.id"-->
      <!--          :options="workSectorsForSelect"-->
      <!--          name="fatherWorkSector"-->
      <!--          :model="localFilters"-->
      <!--          :errors="formErrors"-->
      <!--          label-field="name"-->
      <!--      />-->
      <form-input :label="Lang.get('messages.father_work_sector')" name="fatherWorkSectorKeyword"
        :model="localFilters" />
    </div>

    <div class="col-md-3" v-if="$mods.school_settings.families.father.form_inputs.work_sector_type">
      <form-select :label="Lang.get('messages.father_work_sector')" :options="workSectorTypesForSelect"
        name="fatherWorkSectorType" :model="localFilters" :reduce="(value) => value.id" label-field="name" />
    </div>

    <div class="col-md-3" v-if="$mods.school_settings.families.mother.form_inputs.work_sector">
      <!--      <form-select-->
      <!--          :label="Lang.get('messages.mother_work_sector')"-->
      <!--          :reduce="(value) => value.id"-->
      <!--          :options="workSectorsForSelect"-->
      <!--          name="motherWorkSector"-->
      <!--          :model="localFilters"-->
      <!--          :errors="formErrors"-->
      <!--          label-field="name"-->
      <!--      />-->
      <form-input :label="Lang.get('messages.mother_work_sector')" name="motherWorkSectorKeyword"
        :model="localFilters" />
    </div>


    <div class="col-md-3" v-if="$mods.school_settings.families.mother.form_inputs.work_sector_type">
      <form-select :label="Lang.get('messages.mother_work_sector')" :options="workSectorTypesForSelect"
        name="motherWorkSectorType" :model="localFilters" :reduce="(value) => value.id" label-field="name" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.medical_file_availability')" :options="boolOptions"
        name="medicalFileAvailability" :reduce="value => value.id" :model="localFilters" :errors="formErrors"
        label-field="name" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.working_sons')" :options="boolOptions" name="isParentStaff"
        :reduce="value => value.id" :model="localFilters" :errors="formErrors" label-field="name" />
    </div>



    <div class="col-md-3">
      <form-date :label="Lang.get('messages.from_') + ' ' + Lang.get('messages.join_date')" name="fromJoinedDate"
        :model="localFilters" :errors="formErrors" @change="clearInput('joinedDate')" />
    </div>
    <div class="col-md-3">
      <form-date :label="Lang.get('messages.to_') + ' ' + Lang.get('messages.join_date')" name="toJoinedDate"
        :model="localFilters" :errors="formErrors" @change="clearInput('joinedDate')" />
    </div>
    <div class="col-md-3">
      <form-date :label="Lang.get('messages.from_date')" name="hasInvoicesTransactionsFromDate" :model="localFilters"
        :errors="formErrors" @change="clearInput('fromDate')" />
    </div>

    <div class="col-md-3">
      <form-date :label="Lang.get('messages.to_date')" name="hasInvoicesTransactionsToDate" :model="localFilters"
        :errors="formErrors" @change="clearInput('toDate')" />
    </div>

    <div class="col-md-2" v-if="from_balance">
      <form-input :label="Lang.get('messages.from_number')" name="from" type="number" :model="localFilters" />
    </div>

    <div class="col-md-2" v-if="to_balance">
      <form-input :label="Lang.get('messages.to_number')" name="to" type="number" :model="localFilters" />
    </div>
    <div class="col-md-3" v-if="expenseAt">
      <form-select :label="Lang.get('messages.expense_at') + '(' + Lang.get('messages.registration') + ')'"
        :options="expenseTypesForSelect" name="expenseAt" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(value) => value.id" />
    </div>
    <div class="col-md-3" v-if="previousSchool">
      <form-select :label="Lang.get('messages.school_type')" label-field="name" value-field="id"
        :reduce="(value) => value.id" :options="schoolTypes" name="schoolType" :model="localFilters"
        @change="getPrevSchools()" />
    </div>
    <div class="col-md-3" v-if="previousSchool && route != '/students/report/transformation-student'">
      <form-select :label="Lang.get('messages.external_school')" :options="prevSchoolsForSelect" name="previousSchool"
        :model="localFilters" :reduce="(value) => value.id" :errors="formErrors" label-field="name" />
    </div>
  </div>
</template>

<script>
import { mapState , mapGetters } from "vuex";
import AcademicYear from "@api/academic_year.api"
import YearLevel from "@api/year_level.api";
import School from "@api/school.api";
import Stage from "@api/stage.api";
import Classes from "@api/class.api";
import Students from "@api/student.api";
import Nationality from "@api/nationality.api";
import Organization from "@api/organizations.api";
import District from "@api/district.api";
import Area from "@api/area.api";
import WorkSector from "@api/work_sector.api";
import Religion from "@api/religion.api";
import Student from "@api/student.api";
import Lang from "../../lang";
import PrevSchoolType from "@api/prev_school_type.api";
import PrevSchool from "@api/previous_school.api";
import Parent from "@api/parent.api";

export default {
  name: "RegistrationFilter",
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters(["isSuperadminLoggedSchool"]),

    school() {
      return this.user.school;
    },
  },
  props: {
    filters: {
      type: [Object, Array],
      required: true
    },
    from_balance: {
      type: [Boolean],
      default: false
    },
    to_balance: {
      type: [Boolean],
      default: false
    },
    expenseAt: {
      type: [Boolean],
      default: true
    },
    showAcademicYear: {
      type: [Boolean],
      default: true
    },
    showAnotherAcademicYear: {
      type: [Boolean],
      default: false
    },
    studyStatus: {
      type: [Boolean],
      default: true
    },
    previousSchool: {
      type: [Boolean],
      default: false
    }
  },
  watch: {
    localFilters() {
      this.$emit('filtersUpdated', this.localFilters);
    }
  },
  async created() {
    this.localFilters = _.cloneDeep({
      school: 0,
      academicYear: '',
      stageEnrollment: '',
      yearLevelEnrollment: '',
      classEnrollment: '',
      religion: [],
      enrolledAcademicYear: [],
      gender: [],
      nationalityKeyword: [],
      studentType: [],
      registrationType: [],
      districtId: [],
      areaId: [],
      medicalFileAvailability: [],
      isParentStaff: [],
      studentStatus: [],
      expenseAt: [],
      schoolType: [],
      previousSchool: [],
      code: '',
      civilId: '',
      fatherCivilId: '',
      fatherWorkSectorKeyword: '',
      motherWorkSectorKeyword: '',
      fromJoinedDate: '',
      toJoinedDate: '',
      fromDate: '',
      toDate: '',
      from: '',
      to: '',
    });
    this.UnspecifiedNationalitiesForSelect = [
      { id: 0, name: Lang.get('messages.yes_unspecified_nationality') },
      { id: 1, name: Lang.get('messages.no_unspecified_nationality') },
    ]
    // set value of school select

    if (this.school && !this.isSuperadminLoggedSchool) {
      this.SchoolsForSelect = [{
        id: this.school.id,
        name: this.school.name
      }]
       _.set(this.localFilters, 'school', this.school.id);
      this.names["selectedSchoolName"] = this.school.name;
      this.$emit('updateNames', this.names);
    }
    else {
      School.list({ page: 0 }).then(({ data: { data } }) => {
        this.SchoolsForSelect = data;
        this.$set(this.filters, 'school', data.map(s => s.id));
        //this.updateSelectedNames();
      });
    }

    await this.getWorkSectorTypes();
    this.getAcademicYears();
    await this.loadAllDataToSelects();
    await this.getRegistrationStatus();
    await this.getStudyStatus();

  },
  data() {
    return {
      localFilters: {},
      academicYears: [],
      UnspecifiedNationalitiesForSelect: [],
      yearLevelForSelect: [],
      SchoolsForSelect: [],
      stagesForSelect: [],
      classes: [],
      studentStatus: [],
      religionsForSelect: [],
      nationalitiesForSelect: [],
      genderForSelect: [],
      studentTypesForSelect: [],
      workSectorsForSelect: [],
      expenseTypesForSelect: [],
      districts: [],
      areas: [],
      names: [],
      prevSchoolsForSelect: [],
      schoolTypes: [],
      unspecifiedNationalityStatus: false,
      boolOptions: [],
      studyStatusForSelect: [],
      registrationStatusForSelect: [],
      dateOptions: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "j F, Y",
      },
      workSectorTypesForSelect: [],
      route: this.$route.path,
    }
  },
  methods: {
    async loadAllDataToSelects() {
      this.$set(this.localFilters, 'stageEnrollment', "");
      this.$set(this.localFilters, 'yearLevelEnrollment', "");
      this.$set(this.localFilters, 'classEnrollment', "");
      await this.getStages();
      await this.getNationalities();
      await this.getGenderTypes();
      await this.getStudentTypes();
      await this.getDistrict();
      await this.getWorkSectors();
      await this.getStudentStatus();
      await this.getReligions();
      await this.getExpenseTypes();
      this.getBooleanOptions();
      await this.getSchoolTypes();

    },
    async getWorkSectorTypes() {
      await Parent.getWorkSectorTypes().then(res => {
        this.workSectorTypesForSelect = res.data.types
      });
    },
    async getSchoolTypes() {
      this.schoolTypes = _.cloneDeep([]);
      PrevSchoolType.list({
        page: 0,
        school: this.localFilters.school,
      }).then(response => {
        this.schoolTypes = response.data.data.length ? response.data.data : [];
      });
    },
    async getPrevSchools() {
      this.prevSchoolsForSelect = _.cloneDeep([]);

      await PrevSchool.list({
        page: 0,
        school: this.localFilters.school,
        schoolType: this.localFilters.schoolType,
      }).then((res) => {
        this.prevSchoolsForSelect = res.data.data;
      });
    },
    unspecifiedNationalityStatusChange(val) {
      this.unspecifiedNationalityStatus = val;
      // this.unspecifiedNationalityStatus = val.status;
    },
    getBooleanOptions() {
      this.boolOptions = [
        { id: 1, name: this.Lang.get("messages.yes") },
        { id: 0, name: this.Lang.get("messages.no") },
      ];
    },
    getReligions() {
      Religion.list({
        page: 1,
        school: this.localFilters.school
      }).then(res => {
        this.religionsForSelect = res.data.data
      })
    },
    getStudentStatus() {
      Students.getStatusTypes({ customStatus: true }).then(res => {
        this.studentStatus = res.data.types
      })
    },
    getWorkSectors() {
      WorkSector.list({ page: 0 }).then(res => {
        this.workSectorsForSelect = res.data.data
      })
    },
    async getDistrict() {
      District.list({ page: 0 }).then(({ data: { data } }) => (this.districts = data));
    },
    async getArea() {
      Area.list({ page: 0, district: this.localFilters.districtId }).then(({ data: { data } }) => (this.areas = data));
    },
    getStudentTypes() {
      Organization.getStudentTypes().then(res => {
        this.studentTypesForSelect = res.data.data
      })
    },
    getGenderTypes() {
      Students.getGenderTypes().then((res) => {
        this.genderForSelect = res.data.data;
      });
    },
    async getNationalities() {
      _.set(this.nationalitiesForSelect, [])
      Nationality.list({
        page: 0,
        school: this.localFilters.school
      }).then(res => {
        this.nationalitiesForSelect = res.data.data
      })
    },
    getStages() {
      Stage.list({
        page: 0, school: this.localFilters.school,
      }).then(res => {
        this.stagesForSelect = res.data.data
      })
    },
    async getYearLevels() {

      if (!this.localFilters.stageEnrollment) {
        this.yearLevelForSelect = [];
      }

      YearLevel.list({
        page: 0,
        school: this.localFilters.school,
        stage: this.localFilters.stageEnrollment
      }).then(res => (this.yearLevelForSelect = res.data.data));
    },
    async getClasses() {
      this.classes = [];
      if (!this.localFilters.yearLevelEnrollment || (this.$mods.school_settings.classes.form_inputs.multi_academic_years && !this.localFilters.academicYear)) {
        this.classes = [];
        return false;
      }

      await Classes.list({
        page: 0,
        yearLevel: _.get(this.localFilters, 'yearLevelEnrollment'),
        school: this.localFilters.school,
        academicYears: this.$mods.school_settings.classes.form_inputs.multi_academic_years ? _.get(this.localFilters, 'academicYear') : ''
      }).then((res) => (this.classes = res.data.data));

    },
    getAcademicYears() {
      AcademicYear.list({
        page: 0
      }).then(
        ({ data: { data } }) => {
          (this.academicYears = data)
          this.$set(this.localFilters, 'academicYear', data.filter(year => year.active)[0].id || 0);
          this.$set(this.localFilters, 'academicYearEnrollment', data.filter(year => year.active)[0].id || 0);
          if (this.$mods.school.ahlia) {
            this.$set(this.localFilters, 'hasInvoicesTransactionsOrFunded', data.filter(year => year.active)[0].id || 0);
            this.$set(this.localFilters, 'enrollment', 1);
            this.$set(this.localFilters, 'withoutGlobalScope', 'existStudent');
          }
        });
    },
    updateSelectedNames() {
      if (this.localFilters.hasOwnProperty('school')) {
        this.names["selectedSchoolName"] = _.get(this.SchoolsForSelect.find(item => item.id === this.localFilters.school), 'name');
      }
      if (this.localFilters.hasOwnProperty('yearLevelEnrollment')) {
        this.names["selectedYearLevelName"] = _.get(this.yearLevelForSelect.find(item => item.id === this.localFilters.yearLevelEnrollment), 'name');
      }
      if (this.localFilters.hasOwnProperty('classEnrollment')) {
        this.names["selectedClassName"] = _.get(this.classes.find(item => item.id === this.localFilters.classEnrollment), 'name');
      }
      this.$emit('updateNames', this.names);
    },

    setEnrollment() {
      if (this.localFilters.academicYear) {
        this.$set(this.localFilters, 'academicYearEnrollment', _.get(this.localFilters, 'academicYear'));
        if (this.$mods.school.ahlia) {
          this.$set(this.localFilters, 'hasInvoicesTransactionsOrFunded', _.get(this.localFilters, 'academicYear'));
          this.$set(this.localFilters, 'enrollment', 1);
          this.$set(this.localFilters, 'withoutGlobalScope', 'existStudent');
        }

        this.$set(this.localFilters, 'classEnrollment', "");
        this.getClasses();
      }

    },
    async getExpenseTypes() {
      await Student.getExpenseTypes()
        .then(response => {
          this.expenseTypesForSelect = response.data.data.length ? response.data.data : [];
        });
    },
    async getRegistrationStatus() {
      await Students.getRegistrationStatus().then(res => {
        this.registrationStatusForSelect = res.data.types
      });
    },
    async getStudyStatus() {
      await Students.getStudyStatus().then(res => {
        this.studyStatusForSelect = res.data.types
      });
    },
  }
}
</script>

<style scoped></style>